export default class TrackEmojiUsage {
  constructor(context) {
    this.context = context;
  }

  run({ name }) {
    this.context.analytics.track('Emoji Used', { name });
  }
}
